"use strict";var DeviceDisclosureStorageAccessType;Object.defineProperty(exports,"__esModule",{value:!0}),function(e){e.COOKIE="cookie",e.WEB="web",e.APP="app"}(DeviceDisclosureStorageAccessType=exports.DeviceDisclosureStorageAccessType||(exports.DeviceDisclosureStorageAccessType={}));


//////////////////
// WEBPACK FOOTER
// ../node_modules/@iabtcf/core/lib/model/DeviceDisclosureStorageAccessType.js
// module id = 50
// module chunks = 0